export default {
  state: {
    selectedYear: '2024',
  },
  mutations: {
    ['CHANGE_YEAR'](state, year) {
      state.selectedYear = year;
    },
  },
  actions: {
    setSelectedYear({ commit }, year) {
      commit('CHANGE_YEAR', year);
    },
  },
  getters: {
    selectedYear(state) {
      return state.selectedYear;
    },
  },
};
